import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../../services/user/user.service';
import { DataSharingService } from '../../../auth/data-sharing.service';




@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  isUserLoggedIn: boolean;
  currentUserData: any;

  isUserAdmin: boolean;
  isUserEmployee: boolean;
  isUserVendor: boolean;

  public isUserSm: boolean;
  public isUserEn: boolean;
  public isUserHr: boolean;
  public isUserFn: boolean;
  public isUserIt: boolean;
  public isUserQa: boolean;
  public isUserPm: boolean;
  public isUserAd: boolean;
  public isUserEhs: boolean;
  public isUserMt: boolean;

  constructor(private router: Router, private userService: UserService,
    private dataSharingService: DataSharingService) {

    this.dataSharingService.isUserLoggedIn.subscribe(
      value => {
        this.isUserLoggedIn = value;
      });

    this.userService.isUserAdmin.subscribe(
      value => {
        this.isUserAdmin = value;
      });

    this.userService.isUserEmployee.subscribe(
      value => {
        this.isUserEmployee = value;
      });

    this.userService.isUserVendor.subscribe(
      value => {
        this.isUserVendor = value;
      });

    this.userService.isUserSm.subscribe(
      value => {
        this.isUserSm = value;
      });

    this.userService.isUserEn.subscribe(
      value => {
        this.isUserEn = value;
      });

    this.userService.isUserHr.subscribe(
      value => {
        this.isUserHr = value;
      });

    this.userService.isUserFn.subscribe(
      value => {
        this.isUserFn = value;
      });

    this.userService.isUserIt.subscribe(
      value => {
        this.isUserIt = value;
      });

    this.userService.isUserQa.subscribe(
      value => {
        this.isUserQa = value;
      });

    this.userService.isUserPm.subscribe(
      value => {
        this.isUserPm = value;
      });

    this.userService.isUserAd.subscribe(
      value => {
        this.isUserAd = value;
      });

    this.userService.isUserEhs.subscribe(
      value => {
        this.isUserEhs = value;
      });

    this.userService.isUserMt.subscribe(
      value => {
        this.isUserMt = value;
      });

  }

  ngOnInit() {
    /* commented on 06012021
    this.userService.currentUser.subscribe(
      (userdata) => {
        this.currentUserData = userdata;
      }
    );
    */

    this.userService.getUserProfile().subscribe(
      (userdata) => {
        this.currentUserData = userdata;
      }
    );

  }

  ngAfterViewInit() {
    document.getElementById("toogleRight").style.visibility = "hidden";
  }

  toggleLeftSide() {
    //alert("hello");
    //document.getElementById("leftsidebar").style.display = "none";
    document.getElementById("leftsidebar").style.visibility = "hidden";
    document.getElementById("page-wrapper").style.paddingLeft = "0px";
    document.getElementById("toogleRight").style.visibility = "visible";
    document.getElementById("toogleLeft").style.visibility = "hidden";

  }

  toggleRightSidebar() {
    //alert("hello");
    //document.getElementById("leftsidebar").style.display = "none";
    document.getElementById("leftsidebar").style.visibility = "visible";
    document.getElementById("page-wrapper").style.paddingLeft = "225px";
    document.getElementById("toogleLeft").style.visibility = "visible";
    document.getElementById("toogleRight").style.visibility = "hidden";
  }

  Logout() {
    //localStorage.removeItem("userToken");
    this.userService.purgeAuth();
    this.router.navigate(['/home']);
  }

}
